module.exports = __webpack_public_path__ + "static/media/forbes-black.06360094.png";